import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ok",
  "use": "icon-ok-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ok\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 0a256 256 0 0 1 256 256v768L0 0h768z m17.152 220.16L626.752 378.432l-67.84-67.84a32 32 0 1 0-45.312 45.248L604.16 446.4a32 32 0 0 0 45.248 0l181.056-181.056a32 32 0 1 0-45.248-45.248z\" fill=\"#1afa29\" p-id=\"2128\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ok.svg
// module id = zWFk
// module chunks = 81